
    // Event Delegator für den Button
    document.addEventListener("click", function(event) {
        if (event.target && event.target.id === "meinButton") {
            onClickMeinButton();
        }
    });

    // Funktion, die beim Klicken auf den Button ausgeführt wird
    function onClickMeinButton() {
        console.log("Button geklickt.");

        // API-Endpunkt für den Warenkorb
        var cartEndpoint = "/cart.js";

        // API-Aufruf, um den Warenkorb abzurufen
        fetch(cartEndpoint)
            .then(response => response.json())
            .then(data => {
                // Array, um Varianten-IDs und Mengen zu speichern
                var itemsArray = [];

                // Schleife durch alle Produkte im Warenkorb
                data.items.forEach((item, index) => {
                    var variantId = item.variant_id;
                    var quantity = item.quantity;
                    var sellingPlanId = document.getElementById("sellingPlan").value;
                    if (index === 0) {
                        itemsArray.push("?items[][id]=" + variantId + "%26items[][quantity]=" + quantity + "%26items[][selling_plan]=" + sellingPlanId);
                    } else {
                        itemsArray.push("%26items[][id]=" + variantId + "%26items[][quantity]=" + quantity + "%26items[][selling_plan]=" + sellingPlanId);
                    }
                });

                console.log("Varianten im Warenkorb:", itemsArray);

                // URL zusammenstellen
                var url = "/cart/clear?return_to=/cart/add";
                itemsArray.forEach(item => {
                    url += item;
                });
                url += "%26return_to=/checkout";

                console.log("Zusammengestellte URL:", url);
                // Weiterleitung zur zusammengestellten URL
                window.location.href = url;

            })
            .catch(error => console.error("Fehler beim Abrufen des Warenkorbs:", error));
    }




 /*   // Funktion, die beim Klicken auf den Button ausgeführt wird
    function onClickMeinButton() {
        console.log("Button geklickt.");

        // Eventlistener für den Button
        document.getElementById("meinButton").addEventListener("click", function() {
            // API-Endpunkt für den Warenkorb
            var cartEndpoint = "/cart.js";

            // API-Aufruf, um den Warenkorb abzurufen
            fetch(cartEndpoint)
                .then(response => response.json())
                .then(data => {
                    // Array, um Varianten-IDs und Mengen zu speichern
                    var itemsArray = [];

                    // Schleife durch alle Produkte im Warenkorb
                    data.items.forEach((item, index) => {
                        var variantId = item.variant_id;
                        var quantity = item.quantity;
                        var sellingPlanId = document.getElementById("sellingPlan").value;
                        if (index === 0) {
                            itemsArray.push("?items[][id]=" + variantId + "%26items[][quantity]=" + quantity + "%26items[][selling_plan]=" + sellingPlanId);
                        } else {
                            itemsArray.push("%26items[][id]=" + variantId + "%26items[][quantity]=" + quantity + "%26items[][selling_plan]=" + sellingPlanId);
                        }
                    });

                    console.log("Varianten im Warenkorb:", itemsArray);

                    // URL zusammenstellen
                    var url = "/cart/clear?return_to=/cart/add";
                    itemsArray.forEach(item => {
                        url += item;
                    });
                    url += "%26return_to=/checkout";

                    console.log("Zusammengestellte URL:", url);
                    // Weiterleitung zur zusammengestellten URL
                    window.location.href = url;

                })
                .catch(error => console.error("Fehler beim Abrufen des Warenkorbs:", error));
        });
    }

    // Eventlistener für den Button
    onClickMeinButton();


*/






/* Funktioniert nicht mit Menge änderung

// Funktion, die beim Klicken auf den Button ausgeführt wird
    function onClickMeinButton() {
        console.log("Button geklickt.");

        // API-Endpunkt für den Warenkorb
        var cartEndpoint = "/cart.js";

        // API-Aufruf, um den Warenkorb abzurufen
        fetch(cartEndpoint)
            .then(response => response.json())
            .then(data => {
                // Array, um Varianten-IDs und Mengen zu speichern
                var itemsArray = [];

                // Schleife durch alle Produkte im Warenkorb
                data.items.forEach((item, index) => {
                    var variantId = item.variant_id;
                    var quantity = item.quantity;
                    var sellingPlanId = document.getElementById("sellingPlan").value;
                    if (index === 0) {
                        itemsArray.push("?items[][id]=" + variantId + "%26items[][quantity]=" + quantity + "%26items[][selling_plan]=" + sellingPlanId);
                    } else {
                        itemsArray.push("%26items[][id]=" + variantId + "%26items[][quantity]=" + quantity + "%26items[][selling_plan]=" + sellingPlanId);
                    }
                });

                console.log("Varianten im Warenkorb:", itemsArray);

                // URL zusammenstellen
                var url = "/cart/clear?return_to=/cart/add";
                itemsArray.forEach(item => {
                    url += item;
                });
                url += "%26return_to=/checkout";

                console.log("Zusammengestellte URL:", url);
                // Weiterleitung zur zusammengestellten URL
                window.location.href = url;

                // Hier könntest du die Weiterleitung zur Checkout-Seite einleiten

            })
            .catch(error => console.error("Fehler beim Abrufen des Warenkorbs:", error));
    }

    // Eventlistener für den Button
    document.getElementById("meinButton").addEventListener("click", onClickMeinButton);

*/